import React, {useState} from "react";
import { withRouter } from "react-router-dom";
import { Icon, Form, Upload, Button, Modal, message, Row } from "antd";
import {sendGluster} from "../../../utils/Others/function";

function Gluster(props) {

  const { setLoader } = props;
   const [document, setDocument] = useState([
      { file: [], nameFile: "", url: "" },
    ]);

    const file = {
      name: "file",
      multiple: false,
      showUploadList: {
        showDownloadIcon: false,
      },
      onRemove: (file) => {
        setDocument((state) => {
          return {
            file: [],
          };
        });
      },
      
    beforeUpload: (file) => {
      if (file) {
        setDocument((state) => ({
          file: [file],
        }));
      }
      return false;
    },
      document,
    };
      //Función que guarda la organización
  const addFile = (event) => {
   event.preventDefault();
      if (document.file) {
        setLoader({ loading: true, message: "Actualizando..." })
        sendGluster(document.file[0]).then(res=>{
          setLoader({loading :false , message:""})
          if (res.data.code === 200){
            Modal.success({
              content: res.data.message,
              okText: "Aceptar",
            });
          } else {
            Modal.error({
              content: res.data.message,
            });
          }
        }).catch(()=>{
          setLoader({loading :false , message:""})
          Modal.error({
            content: "Ocurrió un error al subir el archivo",
          });
        })
        setDocument([]);
      }else{
        message.warn("No se ha cargado ningun archivo");
      }
 };

  return (
    <Row style={{textAlign: "center"}}>

      <Form>
        <Form.Item 
        style={{ marginTop: 20 }} 
        >
          <Upload {...file} accept=".jrxml" fileList={document.file}>
            <Button type="default" shape="round" disabled={document.status}>
              <Icon type="upload" />
              Cargar
            </Button>
          </Upload>
        </Form.Item>
        <Form.Item>
          <Button 
          type="primary"
          style={{marginLeft:'15px'}}
          onClick={(e) => {addFile(e);}}
          >
          Guardar
          </Button>
        </Form.Item>
      </Form>
    </Row>
  );
}

export default withRouter(Form.create()(Gluster));
